/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoSociedad from 'Infotrack@Modelos/administracion/tipoSociedad/entidades/tipoSociedad';
import React from 'react';
import TipoSociedadCM from '../controladorModelo/tipoSociedadCM';
import { acciones, IEstadoTipoSociedad } from '../reductorTipoSociedad';
import FormularioTipoSociedadVista from '../vista/formularioTipoSociedadVista';

const estadoInicial: ITipoSociedad = {
    CodigoTipoSociedad: '',
    NombreTipoSociedad: '',
    EstadoTipoSociedad: true,
};
const tipoSociedadCM = new TipoSociedadCM();

const FormularioTipoSociedadCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadTipoSociedad }, dispatch] = useProveedor<IEstadoTipoSociedad>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITipoSociedad>(estadoInicial);

    React.useEffect(() => {
        if (entidadTipoSociedad && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTipoSociedad);
        } else {
            reiniciar();
        }
    }, [entidadTipoSociedad]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };

    const confirmarCreacionEdicionTipoSociedad = () => {
        if (tipoSociedadCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTipoSociedad,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTipoSociedad = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tipoSociedadCM.crearTipoSociedad(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            tipoSociedadCM.editarTipoSociedad(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioTipoSociedadVista
            accionCrearEditar={confirmarCreacionEdicionTipoSociedad}
            cambiarInfoFomulario={alCambiarValor}
            tipoSociedad={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioTipoSociedadCV;
